import React, { Fragment, useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { db } from "../Utils/Firebase";
import { AppContext } from "../Utils/AppContext";
import NotificationsTable from "../Tables/NotificationsTable";
import Page from "../Layout/Page";
import { useGetUser, getUserPhoto } from "../Utils/User";
import UserForm from "../Forms/UserForm";
var moment = require("moment");

const UserAccount = ({ route }) => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;

  const currentAccountId = route.params.userId;
  const [showUserForm, setShowUserForm] = useState(false);

  const { loading: loadingUser, user } = useGetUser(currentAccountId);

  const [userImage, setUserImage] = useState({
    loading: true,
    url: null
  });

  useEffect(() => {
    if (!loadingUser && user.role === "driver") {
      getUserPhoto(user.uid).then(photoUrl =>
        setUserImage({
          loading: false,
          url: photoUrl
        })
      );
    }
  }, [loadingUser]);

  return (
    <Page title="User Account">
      {!loadingUser && (
        <div className="user-detail">
          {!userImage.loading && userImage.url !== null && (
            <img src={userImage.url} alt={`${user.name.firstName} ${user.name.lastName}`} height="auto" width={200} />
          )}

          <br />

          <label htmlFor="name">
            <strong>Name:</strong>
            <p>{user.name && `${user.name.firstName} ${user.name.lastName}`}</p>
          </label>
          <label htmlFor="email">
            <strong>Email:</strong>
            <p>{user.email && user.email}</p>
          </label>
          <label htmlFor="created">
            <strong>User Created:</strong>
            <p>{moment(user.created).format("MM/DD/YY h:mm A")}</p>
          </label>
          <label htmlFor="role">
            <strong>Role:</strong>
            <p>{user.role && user.role}</p>
          </label>
          <label htmlFor="company">
            <strong>Company:</strong>
            <p>{user.company && user.company.name}</p>
          </label>

          {user.role === "driver" && (
            <div>
              <label htmlFor="fleet">
                <strong>Fleet:</strong>
                <p>{user.fleetName}</p>
              </label>
              <label htmlFor="energyLevel">
                <strong>Last Known Energy Level:</strong>
                <p>{user.stats && user.stats.energyLevel}</p>
              </label>
              <label htmlFor="status">
                <strong>Current Status:</strong>
                <p>{user.stats && user.stats.currentStatus}</p>
              </label>
            </div>
          )}
        </div>
      )}

      {showUserForm && (
        <Fragment>
          <UserForm
            cid={currentUser.role !== "super" && currentUser.company.id}
            uid={currentAccountId}
            formComplete={() => {
              setShowUserForm(false);
            }}
          />

          <button
            type="button"
            onClick={() => {
              setShowUserForm(false);
            }}
          >
            Cancel
          </button>
        </Fragment>
      )}

      {!showUserForm && (
        <Fragment>
          <br />

          <button
            type="button"
            onClick={() => {
              setShowUserForm(true);
            }}
          >
            Edit User
          </button>
        </Fragment>
      )}

      {!loadingUser && user.role === "driver" && (
        <div>
          <br />
          <br />
          <NotificationsTable userId={currentAccountId} />
        </div>
      )}
    </Page>
  );
};

export default UserAccount;
